/**
 * Hit-list WebLink rendering helpers (LAX-10228).
 *
 * Customer `Grid-{type}` templates win when already cached. On a cold
 * refresh the cache misses, so every renderer type ending in `WebLink`
 * (Hierarchy `WebLink`, `UdiDiWebLink`, `BasicUdiDiWebLink`, …) gets the
 * same built-in icon fallback. Relative `/browse?` and `/edit/` hrefs
 * are left as-is — do not concatenate a host.
 */
angular.module('llax.services')
    .factory('WebLinkGrid', function() {

        function isWebLinkRendererType(type) {
            return typeof type === 'string' && type.endsWith('WebLink');
        }

        function defaultWebLinkCellTemplate() {
            return '<a data-ng-if="COL_FIELD" data-ng-href="{{COL_FIELD}}" title="WebLink" ' +
                '   target="_blank" rel="noopener noreferrer" class="text-center">' +
                '  <i class="glyphicon glyphicon-link"></i>' +
                '</a>';
        }

        /**
         * Cache lookup stays first so an org-specific `Grid-{type}` still
         * wins. The built-in fallback applies only when the cache misses
         * AND `type` ends with WebLink.
         */
        function resolveWebLinkCellTemplate(type, templateCache) {
            var cached = templateCache && templateCache.get('Grid-' + type);
            if (cached) {
                return cached;
            }
            if (isWebLinkRendererType(type)) {
                return defaultWebLinkCellTemplate();
            }
            return undefined;
        }

        return {
            isWebLinkRendererType: isWebLinkRendererType,
            defaultWebLinkCellTemplate: defaultWebLinkCellTemplate,
            resolveWebLinkCellTemplate: resolveWebLinkCellTemplate
        };
    });
